import { RegistryCategory } from '../RegistryCategory';
export class AspectFilterRegistryCategory extends RegistryCategory {
    get categories() {
        return super.categories;
    }
    get leafs() {
        return super.leafs;
    }
    get allLeafs() {
        return super.allLeafs;
    }
}
